@if (conditionsLoaded()) { @if (mode === 'select') {
<mat-form-field class="w-full">
  <mat-label>Conditions</mat-label>
  <mat-select
    [disabled]="formControl.disabled"
    [formControl]="formControl"
    [multiple]="multiSelect"
  >
    @for ( condition of filter === 'VEHICLE' ? vehicleConditions : filter ===
    'DRIVER' ? driverConditions : filter === 'TRAVELLER' ? travellerConditions :
    filter === 'BOOKING' ? jobConditions : filter === 'ORGANISATION' ?
    organisationConditions : filter === 'MEDALLION' ? medallionConditions : null
    ; track condition) {
    <mat-option [value]="condition"> {{ condition.name }}</mat-option>
    }
  </mat-select>
</mat-form-field>
} @if (mode === 'list') { @if (conditionsLabel) {
<mat-label class="text-sm font-light">{{ conditionsLabel }}</mat-label>
}
<mat-selection-list
  [formControl]="formControl"
  #conditionSelectionList
  class="grid condensed-leading-checkbox-selection-list"
  [ngClass]="'grid-cols-' + columns"
>
  @for ( condition of filter === 'VEHICLE' ? vehicleConditions : filter ===
  'DRIVER' ? driverConditions : filter === 'TRAVELLER' ? travellerConditions :
  filter === 'BOOKING' ? jobConditions : filter === 'ORGANISATION' ?
  organisationConditions : filter === 'MEDALLION' ? medallionConditions : null ;
  track condition) {
  <mat-list-option
    [disabled]="formControl.disabled"
    checkboxPosition="before"
    [value]="condition.networkConditionId"
  >
    {{ condition.name }}
  </mat-list-option>
  }
</mat-selection-list>
} @if (mode === 'switch') {
<div class="grid grid-cols-1 gap-6 w-full">
  @for ( condition of filter === 'VEHICLE' ? vehicleConditions : filter ===
  'DRIVER' ? driverConditions : filter === 'TRAVELLER' ? travellerConditions :
  filter === 'BOOKING' ? jobConditions : filter === 'ORGANISATION' ?
  organisationConditions : filter === 'MEDALLION' ? medallionConditions : [];
  track condition; let i = $index) {
  <fleet-toggle-with-left-label-and-description
    class="w-full"
    [disabled]="
      formControl.disabled ||
      isConditionProcessing(condition.networkConditionId)
    "
    [formControl]="$any(conditionsFormArray.controls[i])"
    [title]="condition.name"
    [description]="condition.description"
    [clickableLabel]="false"
    (checkedChange)="toggleCondition(condition, $event)"
  ></fleet-toggle-with-left-label-and-description>
  }
</div>
} } @else {
<div class="flex justify-center p-6">
  <mat-spinner [diameter]="24"></mat-spinner>
</div>
}
